import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img19 from "../../About/images/19.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person19 = () => {
    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={20}>
            <Flex style={{width: "100%", position: "relative"}} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img19} width={300} preview={false} style={{borderRadius: 20}}/>
                </Fade>

                <Flex style={{width: "100%", position: "relative"}} vertical>
                    <MyText strong size={"large"}>
                        Командиров Евгений Витальевич
                    </MyText>
                    <MyText style={{color: clrs.whiterBlacker}}>
                        Bachelor of Automation and Control, Master of technical sciences
                    </MyText>
                    <br/>
                    <HorizontalDivider/>
                    <br/>
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target="_blank" to="https://orcid.org/0000-0002-3549-8393">
                            <MyText>
                                <LinkOutlined /> Orcid
                            </MyText>
                        </Link>
                    </Flex>
                    <br/>
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        ТОО "Атриум Строй Инвест", инженер АСУ и ТК
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Роль в проекте или программе, а также характер выполняемой работы
                </MyText>
                <MyText size={"small"} italic>
                    Инженер-проектировщик
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Составление схем, чертежей;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Организация передачи данных от автоматизированной системы мониторинга водных ресурсов до АРМ оператора, архивация, визуализация измеряемых данных.
                </MyText>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Краткое обоснование участия
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    М.т.н. по специальности «Автоматизация и управление» по теме «Разработка специализированного оборудования и комплекса лабораторных работ для изучения параметров систем автоматизации». Навыки работы в MatLab+Simulink, AutoCAD. Знание в сфере автоматизации, электротехнике, математического моделирования, проектировании автоматизированных систем мониторинга, создание ЧМИ для визуализации.
                </MyText>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Научные проекты, в которых принимал участие:
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Участвует в проекте программно-целевого финансирования на 2023-2025 гг. ИРН BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия решения в концепте углеродной нейтральности». Роль – исполнитель.
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Участвует в проекте программно-целевого финансирования на 2024-2026 гг. ИРН BR24993128 «Разработка информационно-аналитической системы для принятия решений, обеспечивая эффективное использование трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона». Роль – исполнитель.
                </MyText>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Роль в достижении результатов проекта:
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Создание моделей облачной архитектуры программного комплекса;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Организация передачи данных, архивация, визуализация.
                </MyText>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>
                <MyText size="small" style={{paddingLeft: 20}}>
                    1. Neftissov, A., Kirichenko, L., Kazambayev, I., Vatskel, V., Komandirov, E., Kolesnikova, K. Selection of the optimal method of water resources measurement in Zhambyl province taking into account technical peculiarities.
                </MyText>
                <MyText size="small" style={{paddingLeft: 20}}>
                    2. Kirichenko, L. N., Zhalmagambetova, U. K., Krykbayeva, M. S., Komandirov, E. V., Shimpf, A. A. Methods for determining emissions from major stationary sources of pollution. Торайғыров университетінің хабаршысы, № 3, 2024, pp. 167–182. DOI: 10.48081/HRWJ4394. КОКСОН МНиВО РК.
                </MyText>
            </Flex>
        </Flex>
    );
};